const initialState = () => {
  return {
    firstVisit: true
  };
};

const cookies = {
  namespaced: true,
  state: initialState(),
  getters: {
    firstVisit: state => state.firstVisit
  },
  mutations: {
    setFirstVisit(state, value) {
      state.firstVisit = value;
    }
  },
  actions: {
    closeCookies({ commit }) {
      commit("setFirstVisit", false);
    }
  }
};

export default cookies;
